import React from "react";
import { Link } from "react-router-dom";

import "./components.css";

// Pill-shaped link with the gradient border. Internal routes use the router;
// anything else (mailto:, https:) renders a plain anchor.
export default function FancyButton({ label, linkTo, black, external, ariaLabel }) {
	const className = `fancy ${black ? "black-btn" : "white-btn"}`;
	const content = <span className="content">{label}</span>;

	if (external) {
		// Web pages and files (like the PDF deck) open in a new tab.
		const isWeb = linkTo.startsWith("http") || linkTo.endsWith(".pdf");
		return (
			<a
				className={className}
				href={linkTo}
				aria-label={ariaLabel}
				{...(isWeb && { target: "_blank", rel: "noopener noreferrer" })}
			>
				{content}
			</a>
		);
	}

	return (
		<Link className={className} to={linkTo} aria-label={ariaLabel}>
			{content}
		</Link>
	);
}
